import { Box, Divider, Grid } from '@mui/material'

import AppTable from '../../../components/AppTable/AppTable'

export default function MerchantSalesTab({
    highlights = {},
    rows = [],
    pagination = {},
    loading = false,
    onPageChange,
    formatMoney,
    renderTrend,
}) {
    const topMerchant = highlights.top_merchant || {}
    const fastestGrowing = highlights.fastest_growing || {}
    const posSyncErrors = highlights.pos_sync_errors || {}

    const columns = [
        {
            field: 'id',
            header: '#',
            render: (row) => row.id,
        },
        { field: 'merchant_name', header: 'MERCHANT' },
        { field: 'pos', header: 'POS' },
        {
            field: 'gmv',
            header: 'GMV',
            render: (row) => <b>{formatMoney(row.gmv)}</b>,
        },
        {
            field: 'vs_previous',
            header: 'VS PREVIOUS',
            render: (row) => <>{renderTrend(row.vs_previous, '-')}</>,
        },
        { field: 'orders', header: 'ORDERS' },
        {
            field: 'aov',
            header: 'AOV',
            render: (row) => <>{formatMoney(row.aov)}</>,
        },
        { field: 'dine_in', header: 'DINE IN' },
        { field: 'takeaway', header: 'TAKEAWAY' },
        { field: 'preorder', header: 'PRE ORDER' },
    ]

    return (
        <Box className="merchant-sales-tab">
            <Grid container spacing={2}>
                <Grid item sm={3} xs={6}>
                    <div className="gmv-order-card">
                        <span>Top merchant by GMV</span>
                        <h2>{topMerchant.merchant_name || '-'}</h2>
                        <span>{formatMoney(topMerchant.gmv)} - {topMerchant.orders ?? 0} orders</span>
                    </div>
                </Grid>
                <Grid item sm={3} xs={6}>
                    <div className="gmv-order-card">
                        <span>Fastest growing</span>
                        <h2>{fastestGrowing.merchant_name || '-'}</h2>
                        <span>{renderTrend(fastestGrowing.vs_previous, '0.0%')}</span>
                    </div>
                </Grid>
                <Grid item sm={3} xs={6}>
                    <div className="gmv-order-card">
                        <span>Merchant with no orders</span>
                        <h2>{highlights.merchants_no_orders ?? 0}</h2>
                        <span>offline or no activity</span>
                    </div>
                </Grid>
                <Grid item sm={3} xs={6}>
                    <div className="gmv-order-card">
                        <span>POS sync errors</span>
                        <h2>{posSyncErrors.count ?? 0}</h2>
                        <span>across {posSyncErrors.merchants ?? 0} merchants</span>
                    </div>
                </Grid>
                <Grid item sm={12} my={1} className="flex-container merchant-details-stat-label">
                    MERCHANT PERFORMANCE <Divider style={{ flexGrow: 1 }} />
                </Grid>
                <Grid item sm={12}>
                    <AppTable
                        columns={columns}
                        rows={rows}
                        pagination={pagination}
                        loading={loading}
                        onPageChange={onPageChange}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}
